var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-user-wrapper"},[_c('div',{staticClass:"new-user-wrapper__header"},[_c('BackArrowComp',{attrs:{"goTo":'/users',"text":'New user'}})],1),_c('div',{staticClass:"new-user-wrapper__main"},[_c('NewUserForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }